/**
 * NHN 클라우드 등 외부 URL에서 파일명만 추출하여 표시용으로 반환
 */
export function getMaterialDisplayName(url: string | null | undefined): string {
  if (!url || typeof url !== "string") return "";
  try {
    const withoutQuery = url.includes("?") ? url.slice(0, url.indexOf("?")) : url;
    const pathPart = withoutQuery.replace(/^https?:\/\//, "").split("?")[0];
    const segments = pathPart.split("/").filter(Boolean);
    const last = segments[segments.length - 1];
    if (!last) return url;
    return decodeURIComponent(last);
  } catch {
    return url;
  }
}
